module.exports = __webpack_public_path__ + "public/Icons/tickIcon.png?1602c5cc";